export type WorkflowLogOutcome = "success" | "failure" | "unspecified";

export function workflowLogOutcomeLabel(outcome: WorkflowLogOutcome): string {
  switch (outcome) {
    case "success":
      return "Successful";
    case "failure":
      return "Failed";
    case "unspecified":
      return "Other";
  }
}

export function bucketWorkflowLogStatus(status: string): WorkflowLogOutcome {
  if (matchesToken(status, FAILURE_TOKENS)) return "failure";
  if (matchesToken(status, SUCCESS_TOKENS)) return "success";
  return "unspecified";
}

const FAILURE_TOKENS = ["FAIL"];
const SUCCESS_TOKENS = ["SUCCESS", "SUCCEED", "COMPLETE"];
const STATUS_WORD_RE = /[A-Z]+/g;

// status is free-form text from an external producer, so word-prefix matching (not substring)
// avoids embedded-token false positives: PARTIAL_SUCCESS and "job-1 failed" must count,
// INCOMPLETE and UNSUCCESSFUL must not.
function matchesToken(status: string, tokens: string[]): boolean {
  const words = status.toUpperCase().match(STATUS_WORD_RE) ?? [];
  return words.some((word) => tokens.some((token) => word.startsWith(token)));
}
